import {RampIdType} from '../../generated/graphql';
import {useRecordFeatureFlag} from '../datadog/recordFeatureFlag';
import {useEntityRampFlagWithLoading} from '../useRampFlag';

export function useDeltaQueryCacheEnabled(entityName: string): boolean {
  const {data: cacheEnabled, loading: cacheFlagLoading} =
    useEntityRampFlagWithLoading(
      entityName,
      'enable_delta_query_cache_entity',
      RampIdType.EntityName,
      undefined,
      true
    );
  // Preserve caching until the entity flag explicitly disables it.
  const enabled = cacheFlagLoading || cacheEnabled !== false;
  useRecordFeatureFlag('enable_delta_query_cache_entity', enabled);
  return enabled;
}
